import { Component, OnInit } from '@angular/core';
import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { EstadosRNTEntry } from 'src/app/shared/entrys/estados-rnt-entry';
import { ReportesSoloConsultaService } from './reportes.service';
import { CategoriaEntry } from 'src/app/shared/entrys/categoria.entry';
import { DepartamentoEntry } from 'src/app/shared/entrys/departamento.entry';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { TipoReporte } from 'src/app/shared/enumeraciones/tipo-reporte.enum';

@Component({
	selector: 'app-reportes',
	templateUrl: './reportes.component.html',
	styleUrls: ['./reportes.component.scss']
})
export class ReportesSoloConsultaComponent implements OnInit {
	establecimientos: Array<EstablecimientoEntry>;
	rnts: Array<RNTPrestadorEntry>;
	headersRnt: Array<string>;
	selectEstablecimiento: EstablecimientoEntry;
	dataTabla: DatoPaginadoModel;
	// filtros
	reporte: FormGroup;
	departamentos: Array<DepartamentoEntry>;
	categoriasLista: Array<CategoriaEntry>;
	estadoRNTLista: Array<EstadosRNTEntry>;
	estados = TipoReporte.estados;
	categoria = TipoReporte.categorias;
	departamento = TipoReporte.depatamentos;
	datosGrafica: Array<any>;
	myType = 'ColumnChart';
	configuracionChart: any;
	show = false;
	paginaActual: number;
	constructor(private reportesSoloConsultaService: ReportesSoloConsultaService,
		public fb: FormBuilder
	) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.createForm();
		this.headersRnt = ['Estado', 'Departamento', 'Categoría', 'Cantidad de establecimientos'];
		this.consultarListas();
	}


	onPaginado(value: number) {
		this.consultaTabla(value);
		this.paginaActual = value;
	}


	// filtros
	consultarListas() {
		this.reportesSoloConsultaService.getDepartamentos().subscribe(resultado => {
			if (resultado.result) {
				this.departamentos = resultado.data as Array<DepartamentoEntry>;
			}
		});
		this.reportesSoloConsultaService.getCategorias().subscribe(resultado => {
			if (resultado.result) {
				this.categoriasLista = resultado.data as Array<CategoriaEntry>;
			}
		});
		this.reportesSoloConsultaService.getEstadosRNT().subscribe(resultado => {
			if (resultado.result) {
				this.estadoRNTLista = resultado.data as Array<EstadosRNTEntry>;
			}
		});
	}

	createForm() {
		this.reporte = this.fb.group({
			tipo_reporte: ['', Validators.required],
			reporteGroup: this.fb.group({
				estados_rnt: [''],
				departamentos: [''],
				categorias: ['']
			}, { validator: ConfirmeValidators.inputValidator }),
		});
	}
	enviarForm() {
		this.consultaTabla(1);
		this.obtenerGrafica();
		this.show = true;
		this.paginaActual = 1;
	}
	consultaTabla(value: number) {
		this.reportesSoloConsultaService.getDatosTabla({
			tipo_reporte: this.reporte.value.tipo_reporte,
			lista_estados: this.reporte.value.reporteGroup.estados_rnt ? this.reporte.value.reporteGroup.estados_rnt.join(',') : '',
			lista_departamentos: this.reporte.value.reporteGroup.departamentos ? this.reporte.value.reporteGroup.departamentos.join(',') : '',
			lista_categorias: this.reporte.value.reporteGroup.categorias ? this.reporte.value.reporteGroup.categorias.join(',') : '',
		}, value)
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	obtenerGrafica() {
		this.reportesSoloConsultaService.getDatosGrafica({
			tipo_reporte: this.reporte.value.tipo_reporte,
			lista_estados: this.reporte.value.reporteGroup.estados_rnt ? this.reporte.value.reporteGroup.estados_rnt.join(',') : '',
			lista_departamentos: this.reporte.value.reporteGroup.departamentos ? this.reporte.value.reporteGroup.departamentos.join(',') : '',
			lista_categorias: this.reporte.value.reporteGroup.categorias ? this.reporte.value.reporteGroup.categorias.join(',') : '',
		}).subscribe(resultado => {
			if (resultado.data) {
				this.datosGrafica = resultado.data.map(data => [data.desc_estado_rnt || data.desc_dpto || data.desc_categoria, data.cantidad]);
				if (this.reporte.value.tipo_reporte === this.estados) {
					this.configuracionChart = {
						colors: ['#00bfa5'],
						vAxes: {
							0: { title: 'Cantidad' }
						},
						hAxes: {
							0: { title: 'Estados' }
						}
					};
				} else if (this.reporte.value.tipo_reporte === this.departamento) {
					this.configuracionChart = {
						colors: ['#6a1b9a'],
						vAxes: {
							0: { title: 'Cantidad' }
						},
						hAxes: {
							0: { title: 'Departamentos' }
						}
					};
				} else {
					this.configuracionChart = {
						colors: ['#303f9f'],
						vAxes: {
							0: { title: 'Cantidad' }
						},
						hAxes: {
							0: { title: 'Categorías' }
						}
					};
				}
			} else {
				this.datosGrafica = [];
			}
		});
	}
	limpiar() {
		this.reporte.reset();
		this.paginaActual = 1;
		this.dataTabla = {
			items: [],
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.datosGrafica = [];
		this.show = false;
	}
}
